import { render, staticRenderFns } from "./HabitsTab.vue?vue&type=template&id=2de70798&scoped=true"
import script from "./HabitsTab.vue?vue&type=script&lang=js"
export * from "./HabitsTab.vue?vue&type=script&lang=js"
import style0 from "./HabitsTab.vue?vue&type=style&index=0&id=2de70798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de70798",
  null
  
)

export default component.exports